import { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, Gift, XCircle } from "lucide-react";

export default function CrmConfirm() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [data, setData] = useState({});
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    api.get(`/crm/confirm/${token}`).then((r) => { setData(r.data); setState("ok"); }).catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-slate-50 grid place-items-center p-4" data-testid="crm-confirm-page">
      <div className="w-full max-w-md bg-white rounded-3xl border border-slate-200 shadow-xl p-8 text-center">
        {state === "loading" && <p className="text-slate-400">Confirmation en cours…</p>}
        {state === "error" && (
          <><XCircle size={48} className="mx-auto text-red-400" /><h1 className="mt-3 font-heading text-2xl font-extrabold text-slate-900">Lien invalide</h1>
            <p className="mt-2 text-slate-600 text-sm">Ce lien de confirmation n'est plus valide.</p></>
        )}
        {state === "ok" && (
          <div data-testid="crm-confirm-ok">
            <CheckCircle2 size={52} className="mx-auto text-emerald-500" />
            <h1 className="mt-3 font-heading text-2xl font-extrabold text-slate-900">Inscription confirmée 🎉</h1>
            <p className="mt-2 text-slate-600 text-sm">Vous êtes bien inscrit(e){data.business_name ? ` auprès de ${data.business_name}` : ""}.</p>
            {data.welcome_offer && (
              <div className="mt-4 flex items-center justify-center gap-2 rounded-xl bg-orange-50 border border-orange-200 text-[#9A3412] px-4 py-3 text-sm font-semibold">
                <Gift size={18} /> Votre cadeau : {data.welcome_offer}
              </div>
            )}
            <Link to="/" className="mt-5 inline-block text-[#E05638] font-semibold text-sm">Découvrir PROXIreduc-28</Link>
          </div>
        )}
      </div>
    </div>
  );
}
